// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/invoice/invoice.less
// module id = 2984
// module chunks = 0 1